import Litepicker from "litepicker";

import axios from "axios";
import "litepicker/dist/plugins/mobilefriendly";
import * as Popper from "@popperjs/core";
import * as bootstrap from "bootstrap";
import Choices from "choices.js";
export default class PackageForm {
  constructor() {
    console.log("%cPackages Form", "color: yellow");
    this.init();
  }

  init() {
    let url = new URL(window.location);
    let location_id = url.searchParams.get("location_id") ? url.searchParams.get("location_id") : 490;
    let package_id = url.searchParams.get("package_id") ? url.searchParams.get("package_id") : document.querySelector("#package_id").value;
    console.log("location_id", location_id);
    let price_matrix;
    let choicesArray = [];
    let choiceEl = document.querySelector(".js-choice");

    let delivered = url.searchParams.get("delivery") === "1" ? 1 : 0;
    let setUp = url.searchParams.get("setup") === "1" ? 1 : 0;
    let depositWaiver = url.searchParams.get("depositwaiver") === "0" ? 0 : 1;

    let startDate = url.searchParams.get("startDate") ? url.searchParams.get("startDate") : getNiceFriday();
    let endDate = url.searchParams.get("endDate") ? url.searchParams.get("endDate") : getNiceMonday();

    var startDateParts = startDate.split("/");
    var d1 = new Date(Number(startDateParts[2]), Number(startDateParts[1]) - 1, Number(startDateParts[0]));
    var endDateParts = endDate.split("/");
    var d2 = new Date(Number(endDateParts[2]), Number(endDateParts[1]) - 1, Number(endDateParts[0]));
    let difference = d2.getTime() - d1.getTime();
    let days = Math.ceil(difference / (1000 * 3600 * 24));

    let sidebarPrice = document.querySelector(".sidebar-price");
    activateDiscount();
    let toggleDelivery = document.querySelector("#toggle-delivery");
    let dayPrice = document.querySelector("#price-day");
    let discountDayPrice = document.querySelector("#price-discount-day");
    let deliveryPrice = document.querySelector("#delivery-fee");
    let toggleSetUp = document.querySelector("#toggle-set-up");
    let setUpFeeRow = document.querySelector("#toggle-set-up-row");
    //let deliveredFeeRow = document.querySelector("#toggle-delivered-row");
    let waiverFeeRow = document.querySelector("#toggle-damage-row");

    let deliveryRow = document.querySelector("#toggle-delivery-row");
    //let damageWaiverRow = document.querySelector("#toggle-damage-row");

    let setUpFee = document.querySelector("#set-up-fee");
    let toggleDamageDeposit = document.querySelector("#toggle-damage-deposit");
    let DamageDepositFee = document.querySelector("#damage-deposit-waiver");
    let DamageDepositRow = document.querySelector("#damage-deposit-row");
    let hireChargerRow = document.querySelector("#hire-charge-row");
    let loadingEL = document.querySelector(".package-sidebar__loading");

    const picker = new Litepicker({
      element: document.getElementById("startDate"),
      elementEnd: document.getElementById("endDate"),
      singleMode: false,
      autoRefresh: true,
      numberOfColumns: 2,
      numberOfMonths: 2,
      format: "DD/MM/YYYY",
      repick: true,
      plugins: ["mobilefriendly"],
      mobilefriendly: {
        breakpoint: 780,
      },
      tooltipNumber: (totalDays) => {
        return totalDays - 1 < 1 ? 1 : totalDays - 1;
      },
    });
    picker.setDateRange(startDate, endDate);

    let apiURL = "/wp-json/wordpressmega/v2/package-prices?package_id=" + package_id;

    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      apiURL = "http://soundfangled.local/wp-json/wordpressmega/v2/package-prices?package_id=" + package_id;
    }
    axios.get(apiURL).then(function (response) {
      price_matrix = response.data;
      price_matrix.forEach((element) => {
        let choice = [];
        choice["label"] = element["location"]["post_title"];
        choice["value"] = element["location"]["ID"];
        if (element["location"]["ID"] == location_id) {
          choice["selected"] = true;
        }
        choicesArray.push(choice);
      });

      const choices = new Choices(choiceEl, {
        choices: choicesArray,
      });

      choiceEl.addEventListener(
        "choice",
        function (event) {
          loadingEL.classList.add("package-sidebar__loading--active");
          location_id = event.detail.choice.value;

          if (history.pushState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?location_id=" + location_id;
            // window.history.pushState({ path: newurl }, "", newurl);
            window.history.replaceState({ path: newurl }, "", newurl);
          }
          updatePrices();
        },
        false
      );

      if (delivered) {
        toggleDelivery.checked = true;
        deliveryPrice.classList.toggle("booking-sidebar-switch__price--on");
        setUpFeeRow.classList.toggle("booking-sidebar-switch--activated");

        if (setUp) {
          toggleSetUp.checked = true;
          setUpFee.classList.toggle("booking-sidebar-switch__price--on");
        }
      } else {
        setUp = 0;
      }

      if (depositWaiver) {
        // console.log('depositWaiver', depositWaiver);
        toggleDamageDeposit.checked = true;
        DamageDepositFee.classList.toggle("booking-sidebar-switch__price--on");
        DamageDepositRow.classList.add("hide");
      }

      updatePrices();

      picker.on("selected", (date1, date2) => {
        difference = date2.getTime() - date1.getTime();
        days = Math.ceil(difference / (1000 * 3600 * 24));
        days = days < 1 ? 1 : days;
        activateDiscount();

        startDate = date1.dateInstance.toLocaleDateString("en-GB");
        endDate = date2.dateInstance.toLocaleDateString("en-GB");

        updatePrices();
      });

      toggleDelivery.addEventListener("click", () => {
        deliveryPrice.classList.toggle("booking-sidebar-switch__price--on");
        setUpFeeRow.classList.toggle("booking-sidebar-switch--activated");
        delivered = !delivered;
        document.querySelector("input[name='delivery']").value = delivered ? 1 : 0;

        if (!delivered && setUp) {
          toggleSetUp.click();
        } else {
          updatePrices();
        }
      });

      toggleSetUp.addEventListener("click", () => {
        setUpFee.classList.toggle("booking-sidebar-switch__price--on");
        setUp = !setUp;
        document.querySelector("input[name='setup']").value = setUp ? 1 : 0;
        updatePrices();
      });

      toggleDamageDeposit.addEventListener("click", () => {
        depositWaiver = !depositWaiver;
        // console.log('Toggle deposit', depositWaiver);
        document.querySelector("input[name='depositwaiver']").value = depositWaiver ? 1 : 0;
        DamageDepositFee.classList.toggle("booking-sidebar-switch__price--on");
        if(depositWaiver) {
          DamageDepositRow.classList.add("hide");
        } else {
          DamageDepositRow.classList.remove("hide");
        }

        updatePrices();
      });
    });

    function updateURL() {
      if (history.pushState) {
        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?location_id=" +
          location_id +
          "&delivery=" +
          (delivered ? 1 : 0) +
          "&setup=" +
          (setUp ? 1 : 0) +
          "&depositwaiver=" +
          (depositWaiver ? 1 : 0) +
          "&startDate=" +
          startDate +
          "&endDate=" +
          endDate;

        window.history.pushState({ path: newurl }, "", newurl);
      }
    }

    function getNiceFriday() {
      var d = new Date();
      d.setDate(d.getDate() + 2 * 7);
      d.setDate(d.getDate() + ((5 + 7 - d.getDay()) % 7 || 7));
      return d.toLocaleDateString("en-GB");
    }

    function getNiceMonday() {
      var d = new Date();
      d.setDate(d.getDate() + 2 * 7);
      d.setDate(d.getDate() + ((5 + 7 - d.getDay()) % 7 || 7) + 3);
      return d.toLocaleDateString("en-GB");
    }

    function updatePrices() {
      let priceDay;
      let priceDiscountDay;
      let priceDelivery;
      let priceSetUp;
      let priceDayWaiver;
      let priceDamage;
      // console.log("price_matrix", price_matrix);
      price_matrix.forEach((element) => {
        if (element["location"]["ID"] == location_id) {
          priceDay = +element["day_rate"];
          priceDiscountDay = +element["discount_day_rate"];
          priceDelivery = +element["delivery"];
          priceSetUp = +element["set_up"];
          priceDayWaiver = +element["damage_deposit_waiver"];
          priceDamage = +element["damage_deposit"];
        }
      });

      if (priceDelivery == 0) {
        deliveryRow.classList.add("hide");
      } else {
        deliveryRow.classList.remove("hide");
      }
      if (priceSetUp == 0) {
        setUpFeeRow.classList.add("hide");
      } else {
        setUpFeeRow.classList.remove("hide");
      }
      if (priceDayWaiver == 0) {
        waiverFeeRow.classList.add("hide");
        // DamageDepositRow.classList.add("hide");
      } else {
        waiverFeeRow.classList.remove("hide");
        // DamageDepositRow.classList.remove("hide");
      }

      if (priceDelivery == 0 && priceDayWaiver == 0) {
        hireChargerRow.classList.add("hide");
      } else {
        hireChargerRow.classList.remove("hide");
      }

      let hirePrice = days >= 3 ? days * priceDiscountDay : days * priceDay;
      let waiverTotalPrice = days * priceDayWaiver;

      let total = hirePrice;
      if (delivered) {
        total += priceDelivery;
      }
      if (setUp) {
        total += priceSetUp;
      }
      if (depositWaiver) {
        total += waiverTotalPrice;
      } else {
        total += priceDamage;
      }

      dayPrice.innerHTML = priceDay;
      discountDayPrice.innerHTML = priceDiscountDay;
      document.querySelectorAll(".delivery-price").forEach((element) => {
        element.innerHTML = priceDelivery;
      });
      document.querySelectorAll(".set-up-price").forEach((element) => {
        element.innerHTML = priceSetUp;
      });
      document.querySelector(".damage-day-price").innerHTML = priceDayWaiver;
      document.querySelector(".damage-total-price").innerHTML = waiverTotalPrice;
      document.querySelector("#damage-deposit").innerHTML = priceDamage;
      document.querySelector("#total-hire-charge").innerHTML = hirePrice;
      document.querySelector("#total-charge").innerHTML = total;
      loadingEL.classList.remove("package-sidebar__loading--active");

      updateURL();
    }

    function activateDiscount() {
      if (days >= 3) {
        sidebarPrice.classList.add("sidebar-price--activated");
      } else {
        sidebarPrice.classList.remove("sidebar-price--activated");
      }
    }
  }
}
